// 1. Import necessary components
import { readonly, ref } from 'vue';
import { Network } from '@capacitor/network';

// 2. Use

// 3. Define a reactive variable
const isConnected = ref(true);
const isNetworkReady = ref(false);
const connectionType = ref('unknown');

let networkListener = null;
let monitorPromise = null;

// 4. Define methods or computed properties if needed
// 4.1 Define methods
const applyNetworkStatus = (status) => {
  isConnected.value = status.connected;
  connectionType.value = status.connectionType;
  isNetworkReady.value = true;
};

const refreshNetworkStatus = async () => {
  const status = await Network.getStatus();
  applyNetworkStatus(status);
  return status.connected;
};

const startNetworkMonitoring = () => {
  if (monitorPromise) return monitorPromise;

  monitorPromise = (async () => {
    networkListener = await Network.addListener('networkStatusChange', applyNetworkStatus);
    await refreshNetworkStatus();
  })().catch((error) => {
    monitorPromise = null;
    throw error;
  });

  return monitorPromise;
};

const stopNetworkMonitoring = async () => {
  await networkListener?.remove();
  networkListener = null;
  monitorPromise = null;
};

export function useNetworkStatus() {
  return {
    isConnected: readonly(isConnected),
    isNetworkReady: readonly(isNetworkReady),
    connectionType: readonly(connectionType),
    refreshNetworkStatus,
    startNetworkMonitoring,
    stopNetworkMonitoring,
  };
}
